<div
  style="position:fixed; background: #fff; right: 1rem; top: 20vh; border-radius:4px; border: 1px solid #888; padding: 1rem; z-index: 1000; max-height: calc(80vh - 2rem); overflow-y: scroll;">
  <pre> {{ value | json }}</pre>
</div>
